import React from 'react';
import { Section } from './ui/Section';
export function ThePromise() {
  return <Section background="white" className="text-center" data-id="element-145">
      <div className="max-w-2xl mx-auto" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-serif text-[#4A4238] mb-8" data-id="element-147">
          The Promise
        </h2>
        <p className="text-lg text-[#8C7E6E] mb-8" data-id="element-148">In 14 days, you'll have:</p>

        <ul className="text-left space-y-4 mb-10 inline-block" data-id="element-149">
          {['A repeatable way to get back to baseline', 'Fewer decisions per day', 'Less visual chaos yelling at you', "A calmer 'next 2 hours' plan"].map((item, i) => <li key={i} className="flex items-center text-[#4A4238] text-lg" data-id="element-150">
              <span className="w-2 h-2 bg-[#7BA99E] rounded-full mr-4 flex-shrink-0" data-id="element-151"></span>
              {item}
            </li>)}
        </ul>

        <p className="text-2xl font-serif italic text-[#4A4238]" data-id="element-152">
          Not perfect days. <br data-id="element-153" />
          <span className="text-[#7BA99E] not-italic font-bold" data-id="element-154">
            More recoverable days.
          </span>
        </p>
      </div>
    </Section>;
}